export const FOOTER_LOCALE_ZHCHT = {
    expandText: 'æ¥çæ´å¤ä¿¡æ¯',
    collapseText: 'æ¥çæ´å¤ä¿¡æ¯'
};
